import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-refundpolicy',
  templateUrl: './refundpolicy.component.html',
  styleUrl: './refundpolicy.component.scss'
})
export class RefundpolicyComponent implements OnInit {
  contentReady: boolean = false;
  isAr: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

  }
}
